export default __webpack_public_path__ + "static/media/ships.6c17716e.png";